import { useEffect, useRef } from 'react';
import AIChatMessage from '../../models/AIChatMessage';

export function useFundOpportunityChatScroll(
  chatContainerRef: React.RefObject<HTMLDivElement | null>,
  messages: AIChatMessage[],
): void {
  const previousMessageCountRef = useRef(0);

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) {
      previousMessageCountRef.current = messages.length;
      return;
    }

    if (messages.length === 0) {
      container.scrollTop = 0;
      previousMessageCountRef.current = 0;
      return;
    }

    const previousCount = previousMessageCountRef.current;
    if (messages.length > previousCount) {
      const lastMessage = messages[messages.length - 1];
      if (lastMessage.role === 'user') {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth',
        });
      } else {
        setTimeout(() => {
          const aiResponseIndex = messages.length - 1;
          const aiResponseElement = container.querySelector(
            `[data-message-index="${aiResponseIndex}"]`,
          ) as HTMLElement | null;

          if (aiResponseElement) {
            const rect = aiResponseElement.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const relativeTop = rect.top - containerRect.top + container.scrollTop;

            container.scrollTo({
              top: relativeTop,
              behavior: 'smooth',
            });
          } else {
            const allMessages = container.querySelectorAll('[data-message-index]');
            if (allMessages.length >= 2) {
              const secondToLastElement = allMessages[allMessages.length - 2] as HTMLElement;
              container.scrollTo({
                top: secondToLastElement.offsetTop,
                behavior: 'smooth',
              });
            } else {
              container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth',
              });
            }
          }
        }, 100);
      }
    }

    previousMessageCountRef.current = messages.length;
  }, [chatContainerRef, messages]);
}
